module.exports = __webpack_public_path__ + "media/assets/images/account/mobile-banner-edf5defb0f006771f71f2d9badee9426.png";